import { Card } from '@/components/ui/card';

const STAT_COLORS = {
  red: 'bg-red-50 text-red-600 border-red-200',
  amber: 'bg-amber-50 text-amber-600 border-amber-200',
  blue: 'bg-blue-50 text-blue-600 border-blue-200',
  green: 'bg-green-50 text-green-600 border-green-200',
  teal: 'bg-teal-50 text-teal-600 border-teal-200',
};

export const StatCard = ({ icon: Icon, label, value, color, onClick }) => {
  return (
    <Card 
      className={`p-4 cursor-pointer hover:shadow-md transition-shadow border ${STAT_COLORS[color]}`}
      onClick={onClick}
      data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}
    >
      <div className="flex items-center gap-3">
        <Icon className="h-8 w-8" />
        <div>
          <p className="text-2xl font-bold">{value}</p>
          <p className="text-sm font-medium">{label}</p>
        </div>
      </div>
    </Card>
  );
};
